module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.81a8568c.woff";